import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { GalleryService } from '../../services/gallery.service';

@Injectable({
  providedIn: 'root',
})
export class UnsubscribeGalleryResolve {
  private galleryService = inject(GalleryService);
  private platformId = inject(PLATFORM_ID);

  async resolve(next: ActivatedRouteSnapshot) {
    if (isPlatformServer(this.platformId)) return;
    try {
      // Using id instead of the usual getFromRoute because this link is only ever used in emails where we specify the id.
      // Its important that this stays that way because we can't unsubscribe with the path, and if the gallery has a password
      // we cant get the id from the path.
      return await firstValueFrom(this.galleryService.getGallery(next.params.galleryId));
    } catch {}
  }
}
